<template>
  <div class="form-main">
    <el-form
      ref="refForm"
      :model="formData"
      :rules="rules"
      :size="formConfig.size"
      :disabled="disabled"
      @submit.native.prevent="formSubmit"
    >
      <el-tooltip
        v-for="(item, index) in column"
        :key="index"
        :disabled="!item.titleMore"
        placement="top"
        :open-delay="500"
      >
        <template v-if="!item.hide && item.type">
          <div v-if="item.titleMore" slot="content" v-html="`${item.title}(${item.titleMore})`" />
          <!-- <div v-if="!item.titleMore" slot="content" v-html="item.title" /> -->
          <el-form-item
            :label="item.title || ' '"
            :prop="isRules ? item.field : ''"
            :required="item.required"
            :style="{ width: item.width || formConfig.width || '240px' }"
          >
            <!-- button -->
            <div
              v-if="item.type === 'button'"
              :class="{ 'form-button': true, 'is-error': item.isError }"
              @click="fnChange(item)"
            >
              {{ item.placeholder }}
              <i :class="item.icon"></i>
            </div>

            <!-- input -->
            <el-input
              v-if="isComponentInput(item)"
              v-model="formData[item.field]"
              :ref="item.field"
              :class="{ 'is-important': item.isImportant, 'input-with-select': true }"
              :type="item.type"
              :disabled="item.disabled"
              :autosize="{ minRows: 4, maxRows: 6 }"
              :placeholder="item.placeholder || `请输入${item.title}`"
              :clearable="!item.selectField"
              @input="fnChange(item)"
            >
              <span v-if="item.prefix" slot="prefix">{{ item.prefix }}</span>
              <span v-if="item.suffix" slot="suffix">{{ item.suffix }}</span>
              <el-select
                v-if="item.selectField"
                v-model="formData[item.selectField]"
                slot="suffix"
                placeholder="请选择"
                style="margin-right: -8px"
              >
                <el-option
                  v-for="(itemOption, indexOption) in item.selectOptions"
                  :key="indexOption"
                  :label="itemOption.key"
                  :value="itemOption.val"
                />
              </el-select>
            </el-input>

            <!-- scope -->
            <div v-if="item.type === 'scope'" class="form-scope">
              <el-input
                v-model="formData[item.field][0]"
                type="number"
                size="mini"
                :placeholder="item.placeholder[0]"
              />
              <span class="p-x-5">{{ item.symbol || '-' }}</span>
              <el-input
                v-model="formData[item.field][1]"
                type="number"
                size="mini"
                :placeholder="item.placeholder[1]"
              />
            </div>

            <!-- autocomplete -->
            <el-autocomplete
              v-if="item.type === 'autocomplete'"
              v-model="formData[item.field]"
              :fetch-suggestions="item.querySearch"
              :placeholder="item.placeholder || `请输入${item.title}`"
              clearable
              @select="fnChange(item)"
            />

            <!-- date-picker -->
            <e-date-picker
              v-if="isComponentDate(item)"
              width="100%"
              :ref="item.field"
              :type="item.type"
              :placeholder="item.placeholder || `请输入${item.title}`"
              :format="item.format"
              :value-format="item.valueFormat"
              :value.sync="formData[item.field]"
              :disabled="item.disabled"
              :disabledDate="item.disabledDate"
              clearable
              @change="fnChange(item)"
            />
            <!-- 
            <el-date-picker
            v-if="isComponentDate(item)"
            v-model="formData[item.field]"
            :ref="item.field"
            :type="item.type"
            :placeholder="item.placeholder || `请输入${item.title}`"
            :format="item.format"
            :value-format="item.valueFormat"
            :disabled="item.disabled"
            />
            -->

            <!-- select -->
            <el-select
              v-if="item.type === 'select'"
              v-model="formData[item.field]"
              :ref="item.field"
              :placeholder="item.placeholder || '请选择'"
              :disabled="item.disabled"
              :remote="item.remote"
              :remote-method="item.remote ? item.remoteMethod : null"
              :multiple="item.multiple || false"
              :collapse-tags="item.collapseTags || false"
              :filterable="item.filterable === false ? false : true"
              clearable
              @change="fnChange(item)"
              @clear="item.remote ? item.remoteMethod() : null"
            >
              <el-option v-if="item.emptyDo && item.emptyDo.title" label="" value="" disabled>
                <el-link
                  type="success"
                  style="display: block"
                  :underline="false"
                  @click="item.emptyDo.fn"
                >
                  {{ item.emptyDo.title }}
                </el-link>
              </el-option>
              <el-option
                v-for="(optionItem, optionIndex) in item.options"
                :key="optionIndex"
                :label="optionItem.key"
                :value="optionItem.val"
                :disabled="optionItem.disabled"
                class="flex flex-y-center"
              >
                <span class="flex-1">
                  {{ optionItem.key.length > 1 ? optionItem.key.split(',')[0] : optionItem.key }}
                </span>
                <div class="flex flex-y-center">
                  <span v-if="optionItem.key.split(',')[1]" class="m-l-10">
                    {{ optionItem.key.split(',')[1] }}
                  </span>
                  <el-link
                    v-if="item.optionDo && item.optionDo.title"
                    class="m-l-10 l-h-1"
                    type="primary"
                    @click="item.optionDo.fn(optionItem)"
                  >
                    {{ item.optionDo.title }}
                  </el-link>
                </div>
              </el-option>
              <template #empty>
                <div style="text-align: center">
                  <div
                    style="
                      padding: 10px 0;
                      margin: 0;
                      text-align: center;
                      color: #999;
                      font-size: 14px;
                    "
                  >
                    无匹配数据
                  </div>
                  <el-link
                    v-if="item.emptyDo && item.emptyDo.title"
                    class="m-y-10"
                    type="primary"
                    @click="item.emptyDo.fn"
                  >
                    {{ item.emptyDo.title }}
                  </el-link>
                </div>
              </template>
            </el-select>

            <!-- radio -->
            <el-radio-group
              v-if="item.type === 'radio'"
              v-model="formData[item.field]"
              :disabled="item.disabled"
            >
              <el-radio
                v-for="(item, index) in item.options"
                :key="index"
                :label="item.val"
                :disabled="item.disabled"
              >
                {{ item.key }}
              </el-radio>
            </el-radio-group>

            <!-- checkbox -->
            <el-checkbox
              v-if="item.type === 'checkbox'"
              v-model="formData[item.field]"
              :disabled="item.disabled"
            >
              {{ item.placeholder }}
            </el-checkbox>

            <!-- switch -->
            <el-switch
              v-if="item.type === 'switch'"
              v-model="formData[item.field]"
              :disabled="item.disabled"
              :active-value="item.activeValue || true"
              :inactive-value="item.inactiveValue || false"
              :active-text="formData[item.field] ? item.activeText : item.inActiveText"
            >
              {{ formData[item.field] }}
            </el-switch>

            <!-- upload_file -->
            <e-upload-file
              v-if="item.type === 'upload_file' && formData[item.field]"
              :list.sync="formData[item.field]"
              :fileSize="item.fileSize"
              :filePrompt="item.filePrompt"
              :limit="item.limit"
              :disabled="disabled || item.disabled"
              :isDelete="item.isDelete"
            />

            <!-- upload_image -->
            <e-upload-image
              v-if="item.type === 'upload_image' && formData[item.field]"
              :list.sync="formData[item.field]"
              :fileType="item.fileType"
              :fileSize="item.fileSize"
              :filePrompt="item.filePrompt"
              :size="item.size"
              :limit="item.limit"
              :disabled="disabled || item.disabled"
              :isDelete="item.isDelete"
            />

            <!-- category -->
            <c-cascader-category
              v-if="item.type === 'category'"
              :list.sync="formData[item.field]"
              :url="item.url"
            />

            <!-- address -->
            <c-cascader-address v-if="item.type === 'address'" :list.sync="formData[item.field]" />

            <!-- txt -->
            <span v-if="item.type === 'txt'" class="form-txt">{{ formData[item.field] }}</span>

            <!-- prompt -->
            <span v-if="item.type === 'prompt'" class="form-prompt">{{ item.placeholder }}</span>
          </el-form-item>
        </template>
      </el-tooltip>
      <!-- <el-form-item
        v-if="$slots.default"
        label=" "
        class="form-operate"
      >
        <slot></slot>
      </el-form-item> -->
      <div v-if="$slots.default">
        <slot></slot>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    config: {
      type: Object,
      default: () => {
        return {}
      }
    },
    column: {
      type: Array,
      default: () => {
        return []
        /**
         * hide 是否隐藏
         *
         * type 类型
         * button 按钮
         * text 输入框(文字), 输入框(分隔) => 1, 4
         * number 输入框(数字) => 2
         * textarea 输入框(段落) => 3
         * autocomplete 自由输入
         * select => 8
         * radio 单选
         * checkbox 复选框
         * switch 开关
         * date 日期(年月日) => 5
         * datetime 日期(年月日时分秒) => 6
         * daterange 日期(日期范围) => 7
         * upload_file 文件 => 9
         * upload_image 图片 => 10
         * category 分类
         * address 地址
         *
         * field 标签值字段
         * title 标签名
         * placeholder 占位符
         * required 是否必填
         * disabled 是否禁用
         *
         * 输入框
         * prefix 前缀
         * suffix 后缀
         *
         * 日期
         * format 日期格式
         * valueFormat 返回日期格式
         *
         * 下拉
         * options 下拉选项列表
         *
         * 设置
         * icon 图标
         * isError 是否报错
         */
      }
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    rules: {
      type: Object,
      default: () => {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {}
    }
  },
  computed: {
    formConfig() {
      let obj = {
        inline: true,
        size: 'mini'
      }
      let result = { ...obj, ...this.config }
      return result
    },
    isRules() {
      return JSON.stringify(this.rules) !== '{}'
    },
    // mainWidth() {
    //   let result = this.formConfig.inline ? 'calc(100% + 10px)' : '100%' // 解决inline时最后一项换行问题
    //   return result
    // },
    formDisplay() {
      let result = this.formConfig.inline ? 'flex' : 'block'
      return result
    },
    labelWidth() {
      return this.formConfig.inline ? 'auto' : '120px'
    },
    contentMarginRight() {
      return this.formConfig.inline ? '10px' : '0'
    }
  },
  watch: {
    data: {
      handler(val) {
        if (JSON.stringify(this.formData) !== JSON.stringify(val)) {
          this.formData = this.$util.deepCopy(val)
        }
      },
      deep: true,
      immediate: true
    },
    formData: {
      handler(val) {
        this.$emit('update:data', this.$util.deepCopy(val))
      },
      deep: true
    }
  },
  methods: {
    isComponentInput(item) {
      let result = item.type === 'text' || item.type === 'textarea' || item.type === 'number'
      return result
    },
    isComponentDate(item) {
      let result =
        item.type === 'date' ||
        item.type === 'datetime' ||
        item.type === 'daterange' ||
        item.type === 'datetimerange'
      return result
    },
    fnChange(item) {
      this.$nextTick(() => {
        if (item.fnChange) item.fnChange()
      })
    },
    formSubmit() {
      this.$emit('submit')
    }
  }
}
</script>

<style lang="less" scoped>
.form-main {
  width: 100%;
  // width: v-bind(mainWidth);
  .form-button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 26px;
    padding: 0 5px;
    color: @colorBlue;
    font-size: 12px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    cursor: pointer;
    &.is-error {
      color: @colorRed;
    }
  }

  .form-txt {
    font-size: 12px;
    color: @colorGrayDeep;
  }
  .form-prompt {
    font-size: 12px;
    color: @colorGrayDeep;
  }
  .form-operate {
    display: block;
  }

  .form-scope {
    display: flex;
    align-items: center;
    font-size: 12px;
  }

  /deep/ .el-form {
    display: v-bind(formDisplay);
    flex-wrap: wrap;

    .is-important {
      &.el-input .el-input__inner,
      &.el-input.is-disabled .el-input__inner {
        color: @colorOrange;
        font-weight: bold;
      }
    }

    // 设置表单内部组件宽度
    .el-input,
    .el-autocomplete,
    .el-select {
      width: 100%;
    }
    .el-radio__label {
      padding-left: 0;
    }

    .el-checkbox__label {
      padding-left: 5px;
      font-size: 12px;
    }

    .el-switch__label * {
      font-size: 12px;
      color: #666;
    }

    .el-form-item {
      display: flex;
      align-items: flex-start;
      &.focusing {
        // background: #e6f7ff;
        outline: none;
        border-radius: 4px;
      }
    }

    // 设置label省略号
    .el-form-item__label {
      max-width: 120px;
      width: v-bind(labelWidth);
      padding-right: 5px;
      font-size: 12px;
      color: @colorBlack;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .el-form-item__content {
      flex: 1;
      line-height: 26px;
      margin-right: v-bind(contentMarginRight);
    }

    .el-range__icon {
      line-height: 22px;
    }

    .el-range-separator {
      line-height: 20px;
    }

    .el-input__suffix-inner {
      background: @colorWhite;
      padding-left: 2px;
      line-height: 28px;
    }
    .is-disabled {
      .el-input__suffix-inner {
        background: @colorGrayF;
      }
    }
  }
}
</style>
